export default __webpack_public_path__ + "static/media/about.f6143fb4.png";